module.exports = __webpack_public_path__ + "img/car_sendai11.43656a84.jpg";